import gql from "graphql-tag";

export const GET_GANTT_ASSIGNMENT_ALGORITHM_DATE_FILTERS = gql`
    query getGanttAssignmentAlgorithmDateFilters($assignmentId: Long!, $algorithm: String, $startDate: Date, $endDate: Date) {
        ganttAssignmentService_algorithmDateFilters(assignmentId: $assignmentId, algorithm: $algorithm, startDate: $startDate, endDate: $endDate)
    }
`;

export const GET_GANTT_ASSIGNMENT_ENTITY_REQUIREMENTS = gql`
    query getGanttAssignmentEntityRequirements($assignmentId: Long!) {
        ganttAssignmentService_ganttAssignmentEntityRequirements(assignmentId: $assignmentId)
    }
`;

export const RUN_GANTT_ASSIGNMENT_ALGORITHM = gql`
    mutation runGanttAssignmentAlgorithm($assignmentId: Long!) {
        ganttAssignmentService_runGanttAssignmentAlgorithm(assignmentId: $assignmentId) {
            id, name, flightsStartDate, flightsEndDate, inputEntitiesCsv, outputEntitiesCsv, algorithmType, readOnly, params { id name configEntityRequirementsJson }, organization { id qualifiedName }
        }
    }
`;

export const BALANCE_MISSIONS = gql`
    mutation balanceMissions($assignmentId: Long!) {
        ganttAssignmentService_balanceMissions(assignmentId: $assignmentId) {
            id, name, flightsStartDate, flightsEndDate, inputEntitiesCsv, outputEntitiesCsv, algorithmType, readOnly, params { id name configEntityRequirementsJson }, organization { id qualifiedName }
        }
    }
`;

export const ASSIGN_MISSIONS_TO_HUMAN_RESOURCES = gql`
    mutation assignMissionsToHumanResources($assignmentId: Long!) {
        ganttAssignmentService_assignMissionsToHumanResources(assignmentId: $assignmentId) {
            id, name, flightsStartDate, flightsEndDate, inputEntitiesCsv, outputEntitiesCsv, algorithmType, readOnly, params { id name configEntityRequirementsJson }, organization { id qualifiedName }
        }
    }
`;

export const CREATE_TASKS = gql`
    mutation createTasks($assignmentId: Long!) {
        ganttAssignmentService_createTasks(assignmentId: $assignmentId) {
            id, name, flightsStartDate, flightsEndDate, inputEntitiesCsv, outputEntitiesCsv, algorithmType, readOnly, params { id name configEntityRequirementsJson }, organization { id qualifiedName }
        }
    }
`;

export const COPY_INPUT_DATA_FROM_DB = gql`
    mutation copyInputDataFromDb($assignmentId: Long!, $config: [CopyInputDataFromDbConfigInput!]!) {
        ganttAssignmentService_copyInputDataFromDb(assignmentId: $assignmentId, config: $config) {
            id, name, flightsStartDate, flightsEndDate, inputEntitiesCsv, outputEntitiesCsv, algorithmType, readOnly, params { id name configEntityRequirementsJson }, organization { id qualifiedName }
        }
    }
`;

export const SAVE_FROM_DISK_CSV_FILES = process.env.NODE_ENV === "development" ? gql`
    mutation saveFromDiskCsvFiles($inputPaths: [String], $outputPaths: [String], $startDate: Date, $endDate: Date, $id: Long) {
        ganttAssignmentDevService_saveFromDiskCsvFiles(inputPaths: $inputPaths, outputPaths: $outputPaths, startDate: $startDate, endDate: $endDate, id: $id)
    }
` : null;

export const COPY_GANTT_ASSIGNMENT_TO_DB = gql`
    mutation copyGanttAssignmentToDb($assignmentId: Long!) {
        ganttAssignmentService_copyGanttAssignmentToDb(assignmentId: $assignmentId)
    }
`;

export const IMPORT_ENTITIES_FROM_CSV = gql`
    query importEntitiesFromCsv($csv: String) {
        ganttAssignmentService_importEntitiesFromCsv(csv: $csv)
    }
`;

export const GET_PATHS_GA = gql`
    mutation getPaths {
        ganttAssignmentDevService_paths
    }
`;

export const RECALCULATE_GANTT_ASSIGNMENT = gql`
    mutation recalculateGanttAssignment($assignmentId: Long!, $startDate: Date, $endDate: Date) {
        ganttAssignmentService_recalculateGanttAssignment(assignmentId: $assignmentId, startDate: $startDate, endDate: $endDate)
    }
`;

export const DELETE_OUTPUT_DATA_FROM_DB = gql`
    mutation deleteOutputDataBetweenDates($startDate: Date, $endDate: Date, $algorithmType: AlgorithmType, $assignmentId: Long!) {
        ganttAssignmentService_deleteOutputDataBetweenDates(startDate: $startDate, endDate: $endDate, algorithmType: $algorithmType, assignmentId: $assignmentId)
    }
`;

export const EXECUTE_ALL_OPERATIONS = gql`
    mutation executeAllOperations($startDate: Date, $endDate: Date) {
        ganttAssignmentService_executeAllOperations(startDate: $startDate, endDate: $endDate)
    }
`;

export const ADD_ENTITIES_IN_INPUT_ENTITIES_CSV = gql`
    mutation addEntitiesToInputEntitiesCsv($ganttAssignmentId: Long!, $entities: Map_String_List_ObjectScalar) {
        ganttAssignmentService_addEntitiesToInputEntitiesCsv(ganttAssignmentId: $ganttAssignmentId, entities: $entities) {
            id, name, flightsStartDate, flightsEndDate, inputEntitiesCsv, outputEntitiesCsv, algorithmType, readOnly, params { id name configEntityRequirementsJson }, organization { id qualifiedName }
        }
    }
`;